import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Schedual } from './types';
export const [ ONE, TWO ] = [ 1, 2 ];

@Injectable({
  providedIn: 'root'
})
export class CxSchedularService {
  edit_id: string | null = '';
  editMode = false;
  module: string = '';
  scheduals: Array<Schedual> = [];
  
  locations = [
    { name: 'Send to end', value: 'end' },
    // { name: 'Downlaod', value: 'download' },
  ]
  fileTypes = [
      { name: 'csv', value: 'csv' },
      { name: 'xlsx', value: 'xlsx' },
      { name: 'pdf', value: 'pdf' },
  ]
  schedulars = [
    { name: 'Every 10 minutes', value: '10-minute' },
    { name: 'Every Hour', value: 'hour' },
    { name: 'Every 12 Hour', value: '12-hour' },
    { name: 'Every 24 Hour', value: '24-hour' },
    { name: 'Custom', value: 'custom' },
  ]
  SCREENS = { ONE, TWO };
  private _currentScreen = ONE;
  public $close: Subject<string> = new Subject();

  constructor (private http: HttpClient) { }

  public get currentScreen () {
      return this._currentScreen;
  }

  public set currentScreen (screen: number) {
    this._currentScreen = screen;
  }

  changeScreen (screen: number = ONE) {
    this.currentScreen = screen;
  }

  onBack (event: MouseEvent) {
    this.currentScreen--;
  }

  close () {
    this.$close.next("close");
  }

  getData (callback?: Function) {
    this.list().subscribe((response: Array<Schedual>) => {
      this.scheduals = response;
      if (callback && typeof callback === 'function') {
        callback(response);
      }
    })
  }

  list () {
    const url = `/datagrid/scheduals?module=${this.module}`;
    return this.http.get<Array<Schedual>>(url);
  }

  get (id: string) {
    const url = `/datagrid/scheduals/${id}`;
    return this.http.get<Schedual>(url);
  }

  delete (id: string) {
    const url = `/datagrid/scheduals/${id}`;
    return this.http.delete(url);
  }

  update (paylod: Schedual) {
      const url = `/datagrid/scheduals/${paylod.id}`;
      return this.http.put(url, paylod);
  }

  create (paylod: Schedual) {
      const url = '/datagrid/scheduals';
      return this.http.post(url, paylod);
  }
}